import { z } from "zod";

export const userSchema = z.object({
  id: z.number().int(),
  email: z.string().email(),
  first_name: z.string().nullable().optional().default(""),
  last_name: z.string().nullable().optional().default(""),
  phone: z.string().nullable().optional().default(""),
  job_title: z.string().nullable().optional().default(""),
  timezone: z.string().nullable().optional().default(""),
});
export type User = z.infer<typeof userSchema>;

export const profileUpdateInputSchema = z.object({
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  phone: z.string().optional(),
  job_title: z.string().optional(),
  timezone: z.string().optional(),
});
export type ProfileUpdateInput = z.infer<typeof profileUpdateInputSchema>;

export const signupInputSchema = z.object({
  first_name: z.string().min(1, "Required"),
  last_name: z.string().min(1, "Required"),
  email: z.string().email(),
  password: z.string().min(8, "Min 8 characters"),
  source_site_slug: z.string().optional(),
});
export type SignupInput = z.infer<typeof signupInputSchema>;

export const loginInputSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof loginInputSchema>;

export const authResponseSchema = z.object({
  authToken: z.string(),
  user: userSchema,
});
export type AuthResponse = z.infer<typeof authResponseSchema>;
